import { getDataCheckComplete } from '../../_services/data.service.js'

/* eslint-disable */
const state = () => ({
    notification : {
        profile: 0,
        asessment: 0,
    } 
})

const mutations = {
    //MEMASUKKAN DATA KE STATE OUTLETS
    ASSIGN_DATA(state, payload) {
        state.notification = payload;
    },
    
}

const actions = {
    //FUNGSI INI UNTUK MELAKUKAN REQUEST DATA QUESTIONS DARI SERVER
    async getDataComplate({ commit, state }, payload) {
      let data_res = await getDataCheckComplete();
      console.log(data_res);
      let data_profile = data_res.data.profile;
      let countComplateProfile =
        data_profile.about +
        data_profile.achievements +
        data_profile.basic_informations +
        data_profile.certifications +
        data_profile.education_histories +
        data_profile.work_experiences +
        data_profile.softskill ;

      let asessment = data_res.data.asessment;
      var count = 0;
      for (const key in asessment) {
        if (Object.hasOwnProperty.call(asessment, key)) {
          const element = asessment[key];
          if(element > 0){
            count++;
          }

        }
      }
      let countAsessmentDone = count;

      let dataComplate = {
        profile : countComplateProfile,
        asessment : countAsessmentDone,
      }
      console.log(dataComplate);
      commit('ASSIGN_DATA', dataComplate);
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
